import React from 'react'
 
import Modal from "../../components/Modal"
import "animate.css/animate.min.css"
import PropTypes from "prop-types"
import Link from "gatsby-link"
import ContentPage from "../../components/content-page"
import Meta from "../../components/meta"
import mentConstant1 from '../../constant/mentConstant1'
import { Left } from 'react-bootstrap/lib/Media'
import MediaRight from 'react-bootstrap/lib/MediaRight'

const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal direction="" className="teamdetails__wrapper" show={show} onHide={onHide}>
      <Modal.Header>
            <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
                    <div className="item_des">{activeItem.post}</div>
                    <div className="item_des">{activeItem.company}</div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
               
              
        <div className="item__desc force-overflow">
          <div className="item__desc_scr" style={{ padding:"0px 10px 0px 0px"}} dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
               
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  )
}

TeamModal.propTypes = {
  activeItem: PropTypes.object,
  show: PropTypes.object,
  onHide: PropTypes.object,
}

export class Index extends React.Component{
    constructor (args) {
    super(args)
    this.state = {
      activeItem: {},
      isShow: false
    }
    
  }

  
  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {}
    })
  }


    render(){
        const { location } = this.props
        const { isShow } = this.state
      
        return(
            <ContentPage>
            <Meta title="Winpe ProClub Mentorship Program | Testimonials." image={"https://winpeforum.com/assets/elements/winpe_proclub_updated_linkimage1.jpg"} location={location} />
                <div className="mentees-wrapper" >
               <div className="container">
               <div className="heading"><h1>Testimonials </h1></div>
              {/* <div className="section_intro_text">Applications for Cohort II are now closed. <br/> 
               <br/>   <div className="heading"> <h1 className="heading">Application Criteria and Application Process</h1></div><br/><br/>
<ul style={{textAlign:"Left"}}><li>
Applicants should be currently employed as an investment professional or as a founder/ co-founder of a funded start-up.</li> 
<li > In case an applicant is employed, she should be a mid-level executive (Level of Vice President or equivalent) with at least 12 years of work experience.</li>
<li>Completed application forms should be accompanied by a CV and a reference, preferably from the current or immediately previous employer, commenting on applicant's professional achievements and personal attributes.</li>
<li>Applicants nominated by Winpe member firms are not required to provide a reference letter. </li></ul>
<br/><br/>
  
<a href="https://proclub.winpeforum.com/static/WinPE_ProClub_Program_Guidelines.pdf" style={{color: "#22316B", textDecoration: "underline"}} target="_BLANK">Click here</a> to view Program overview .<br/><br/>

Contact <a href="mailto:proclub@winpeforum.com" style={{color: "#22316B", textDecoration: "underline"}} target="_BLANK">proclub@winpeforum.com</a> for queries.
        </div> */}
                   
                   <div className="section_intro_text" style={{textAlign: 'justify'}}>
 
                   "Winpe’s mentoring programme provided me with a valuable opportunity to network and openly exchange ideas. It made me think and set goals for myself which I would have not otherwise considered. I am thankful to my mentor for candidly sharing his views, suggestions and experiences with me and for encouraging me to think beyond my set frontiers. Our conversations have helped me develop both on a professional and personal front. I look forward to continuing leveraging the relationships built during the programme."
 <br/><span style={{color:'#BF2026', fontWeight:'600'}}> -Anahita Medhora,  Vice President, Everstone Capital, Cohort I Mentee</span>
  
 <br/><br/>
 "Winpe’s mentoring program was highly valuable for me – I entered the same with a very open mind and many aspects to learn on. I am thankful to have found a mentor who was very experienced and was willing to share her thoughts about a variety of things, very openly with me. My mentor and I, both were very serious about this program and used the opportunity to set objectives ahead of our conversations.  This really helped me maximise my learnings. It wasn’t all serious though - many similarities in our journey made us connect a lot more and there was a personal bonding that got created. I would highly recommend the program to the professionals in the investing community."
 <br/>
 <span style={{color:'#BF2026', fontWeight:'600'}}> -Anshul Jain, Managing Director, Lighthouse Advisors, Cohort I Mentee
</span>
 <br/><br/>
 “As my fellow mentees and I graduate as the first cohort of the mentorship programme designed by Winpe in collaboration with Russel Reynolds, I am not alone in feeling gratitude for the fantastic platform provided by this programme. The first of its kind programme for women from the PE space, it has been a journey of learning from the experiences of some truly remarkable leaders that has inspired us to strive for delivering higher impact and emboldened us to go beyond our comfort zone. Despite it being a year of virtual connections and conversations, the programme strove to make these mentor-mentee relationships deliver great value. What I take back from this platform is an opportunity to not just build a long lasting relationship of guidance with my mentor but also be associated with a group of exceptional women leaders. Truly grateful to Winpe for this.”<br/>
 <span style={{color:'#BF2026', fontWeight:'600'}}> -Asha Krishnan, Operating Director, General Atlantic, Cohort I Mentee
</span>
 <br/><br/>
  
 
 "With the Winpe mentoring programme, I had the opportunity to interact with and learn from fabulous leaders, and the other wonderful women in private equity who were part of my cohort. The" highlight of the programme was the one-on-one mentoring conversations with my mentor, Soumya Rajan, where the sole agenda was my development. Soumya brought her perspective to my context and gave generously of her time, connections and insight to help me grow. I am very grateful to Soumya for being willing to share and build me up. Many thanks to Soumya’s assistant, Allison, who was very thorough about setting up our meetings despite Soumya’s busy schedule. Hurrah to the teams at Winpe and Russell Reynolds for starting and running this timely, thoughtful and well-run programme. "
  <br/>
  <span style={{color:'#BF2026', fontWeight:'600'}}>-Jolly Abraham, Director, True North, Cohort I Mentee</span>
  <br/>  <br/>
 
 “I look forward to being a part of the Winpe Mentorship Program and interacting and learning from inspiring women to help me build the tools necessary for the next phase of my career.”<br/>
 <span style={{color:'#BF2026', fontWeight:'600'}}> -Pallavi Satpute, Counsel, AZB & Partners, Cohort II Mentee</span>
 <br/>  <br/>


 "I have been a part of the second cohort of the Winpe mentorship program in collaboration with Russell Reynolds. Firstly, I want to convey my immense gratitude to Winpe for curating such a programme that is a first of its kind in the industry. Thank you for creating a safe space and a perfect environment to learn and grow! Over the course of this program I had the privilege to learn from the wisdom and experience of my mentor, a relationship I will take with me beyond this program. I urge other firms to sign up to this initiative and offer this great mentoring experience to your fellow senior women colleagues."
  <br/>
  <span style={{color:'#BF2026', fontWeight:'600'}}>-Rochelle D'Souza, Managing Director, Lighthouse Advisors, Cohort II Mentee
</span>
  <br/>  <br/>

  
 "I wanted to thank Winpe & Russel Reynolds for this opportunity and design of this unique mentorship program. My mentor asked the difficult questions and pushed me to think about my career strategically. The conversations also helped articulate my ambition & leadership style, in a way I hadn't thought about before. I believe this is just the start of a much longer relationship. This has been a very valuable program, thoughtfully designed by Winpe."
  <br/>
  <span style={{color:'#BF2026', fontWeight:'600'}}>-Parul Hariharan, Manager - Financial Institutions, Equity, BII, Cohort II Mentee
</span>
  <br/>  <br/>
 
  "As I stepped into a new territory of raising and managing my own fund I leaned on guidance from experienced fund managers. In particular, I am grateful to VT Bharadwaj of A91 for his time and practical advice and to Winpe for enabling this relationship."
  <br/>
  <span style={{color:'#BF2026', fontWeight:'600'}}>-Karuna Jain, Co-Founder & Partner, Enzia Ventures, Cohort II Mentee
</span>
  <br/>  <br/>
  
 "I am excited to work closely with Winpe and the illustrious mentors to 'change the narrative' of my professional journey and use the experience to guide upcoming talent"
  <br/>
  <span style={{color:'#BF2026', fontWeight:'600'}}>-Arshita Kapoor, Investment Professional, Quadria Capital, Cohort III Mentee</span>
  <br/>  <br/>

  
 "Really excited to embark on this journey designed to make women shine in private equity.  A mentor is someone who guides and helps us find the light within ourselves and I am really looking forward to engaging and working with one through this programme. Thank you Winpe and RRA for having me as a part of this cohort "
  <br/>
  <span style={{color:'#BF2026', fontWeight:'600'}}>-Neha Misra, Co-Founder & CEO, The Fin Lit Project, Cohort III Mentee
</span>
  <br/>  <br/>

  
 "I am excited to be a part of the program as it gives me the unique opportunity to interact closely and learn from remarkable industry leaders."
  <br/>
  <span style={{color:'#BF2026', fontWeight:'600'}}>-Parita Ashar, Vice- President, Oman India Joint Investment Fund Management, Cohort III Mentee</span>
  <br/>  <br/>

  
 "What attracts me about this program is the networking I will have with the PE industry woman professionals. I am looking forward to learn from the experiences of my mentors."
  <br/>
  <span style={{color:'#BF2026', fontWeight:'600'}}>-Swati Bansal, Principal - Private Equity, NIIF, Cohort III Mentee</span>
  
 </div>
 

               </div>
               <TeamModal show={isShow} onHide={this.togglePopUp} activeItem={this.state.activeItem} />
            </div>
        </ContentPage>
        )
    }
}
Index.propTypes = {
  location: PropTypes.object
}

export default Index
 


// WEBPACK FOOTER //
// ./src/pages/testimonials/index.js